import React from 'react';

export interface Size {
  size: number;
}

function useWindowSize(): Size {
  const [windowSize, setWindowSize] = React.useState<Size>({
    size: window.innerWidth,
  });

  React.useEffect(() => {
    function handleResize() {
      setWindowSize(() => {
        return { size: window.innerWidth };
      });
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowSize;
}

export default useWindowSize;
